import type { AutonomousSummary } from '../consumer/autonomous';
import type { MonitoringReadState } from '../consumer/polling';
import { riskHref } from '../consumer/workbench';

export function AutonomousStatus({
  state,
  areaId = '',
  details = false,
}: {
  state: MonitoringReadState<AutonomousSummary>;
  areaId?: string;
  details?: boolean;
}) {
  const data = state.status === 'READY' ? state.data : null;
  const status = data?.runner.status ?? 'UNAVAILABLE';
  const freshness = data?.dataStatus ?? 'UNAVAILABLE';
  const labels = { RUNNING: '后台运行中', STOPPED: '后台已停止', UNAVAILABLE: '后台状态不可用' };
  const fresh = {
    READY: '已有合格观测',
    STALE: '数据过期',
    NO_DATA: '尚无合格观测',
    UNAVAILABLE: '数据不可用',
  };
  return (
    <span
      data-vs10-status={status}
      data-vs10-data={freshness}
      role="status"
      title={
        data
          ? `后端时间 ${data.asOf} · 配置 ${data.configRevision} · ${data.registryBackend} · 心跳 ${data.runner.lastHeartbeatAt ?? '未知'} · 最近处理 ${data.runner.lastProcessedAt ?? '未知'}`
          : '读取失败或尚未取得后端状态；不会回退演示数据'
      }
    >
      {state.status === 'LOADING' ? '正在读取后台状态' : labels[status]} · {fresh[freshness]}
      {details && (
        <>
          <br />
          {data && data.dataStatus !== 'UNAVAILABLE' ? (
            <>
              健康 {data.coverage.healthySources} / 启用 {data.coverage.enabledSources} · 未知{' '}
              {data.coverage.unknownSources}
              {data.sources.some(
                (source) => source.health === 'STALE' || source.health === 'NO_DATA',
              ) && (
                <>
                  <br />
                  过期 {data.sources.filter((source) => source.health === 'STALE').length} ·
                  尚无数据 {data.sources.filter((source) => source.health === 'NO_DATA').length}
                </>
              )}
              <br />
              <span data-vs10-unlocated>
                待定位 {data.coverage.unlocatedSources}（UNLOCATED）
              </span>{' '}
              · 不生成地图点位
            </>
          ) : (
            '来源覆盖未知'
          )}
          <br />
          <a href={riskHref('/network', areaId)}>区域与来源 →</a>
          <br />
          <small>区域筛选仅改变查看范围；关闭页面后后台继续。</small>
        </>
      )}
    </span>
  );
}
